import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'

import {
  AvailableHomeSoftwareParams,
  featchHomeSoftwareHistory,
  fetchAvailableHomeSoftware,
  InstallSoftwareUpdateBody,
  installHomeSoftwareUpdate,
} from 'features/home/api'
import {
  HOME_AVAILABLE_SOFTWARE_REDUCER_NAME,
  HOME_SOFTWARE_HISTORY_REDUCER_NAME,
  HOME_SOFTWARE_UPDATE_INSTALL_REDUCER_NAME,
} from 'features/home/consts'

const homeAvailableSoftwareSlice = makeFetchSlice(
  HOME_AVAILABLE_SOFTWARE_REDUCER_NAME
)
export const homeAvailableSoftwareReducer = homeAvailableSoftwareSlice.reducer
export const homeAvailableSoftwareActions = homeAvailableSoftwareSlice.actions

export const fetchHomeAvailableSoftwareThunk = (
  homeId: string,
  params?: AvailableHomeSoftwareParams
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeAvailableSoftwareActions,
        asyncFunc: () => fetchAvailableHomeSoftware(homeId, params),
      })
    } catch (error) {
      console.log('Error fetching home available software', error)
    }
  }
}

const homeSoftwareHistorySlice = makeFetchSlice(
  HOME_SOFTWARE_HISTORY_REDUCER_NAME
)
export const homeSoftwareHistoryReducer = homeSoftwareHistorySlice.reducer
export const homeSoftwareHistoryActions = homeSoftwareHistorySlice.actions

export const fetchHomeSoftwareHistoryThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeSoftwareHistoryActions,
        asyncFunc: () => featchHomeSoftwareHistory(homeId),
      })
    } catch (error) {
      console.log('Error fetching home software history', error)
    }
  }
}

const homeSoftwareUpdateInstallSlice = makeFetchSlice(
  HOME_SOFTWARE_UPDATE_INSTALL_REDUCER_NAME
)

export const homeSoftwareUpdateInstallReducer =
  homeSoftwareUpdateInstallSlice.reducer
export const homeSoftwareUpdateInstallActions =
  homeSoftwareUpdateInstallSlice.actions

export const installHomeSoftwareUpdateThunk = (
  homeId: string,
  partNumber: string,
  body: InstallSoftwareUpdateBody,
  setPercentProgress?: React.Dispatch<React.SetStateAction<number>>
) => {
  return async (dispatch: AppDispatch) => {
    await fetchEdgeDataThunk({
      dispatch,
      actions: homeSoftwareUpdateInstallActions,
      asyncFunc: () =>
        installHomeSoftwareUpdate(homeId, partNumber, body, setPercentProgress),
    })
  }
}
